import React, { Component } from 'react'

import PropTypes from 'prop-types'
import { NotificationManager } from 'react-notifications'

export default class CommentForm extends Component {
  static propTypes = {
    onCloseButtonClick: PropTypes.func,
    onSendButtonClick: PropTypes.func
  }

  static defaultProps = {
    onCloseButtonClick: () => null,
    onSendButtonClick: () => null
  }

  constructor(props) {
    super(props)

    this.state = {
      content: ''
    }
  }

  async onSendButtonClick(e) {
    e.stopPropagation()

    try {
      await this.props.onSendButtonClick(this.state.content)

      this.setState(() => ({
        content: ''
      }))
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
    }
  }

  render() {
    return (
      <div className="comment-form">
        <div className="comment-form__input-wrapper">
          <input
            type="text"
            className="comment-form__input"
            value={this.state.content}
            onChange={e => {
              e.persist()

              this.setState(() => ({
                content: e.target.value
              }))
            }}
          />
          <i className="comment-form__icon fa fa-play" onClick={e => this.onSendButtonClick(e)} />
        </div>
        <div className="text-center">
          <button
            className="comment-form__close-btn"
            onClick={e => {
              this.props.onCloseButtonClick(e)
            }}
          >
            Close
          </button>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/components/MyTrip/CommentForm.js